import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import UsersPage, { getDefaultData } from "components/pages/UsersPage";
import Classes, { UserAccount } from "model";

/**
 * @name CaptureUserListAdded
 * @returns {React.Component}
 * @description 
 */
export default function CaptureUserListAdded(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    let defaultUserAccount = BCMSDefaultModel.userAccount();
    defaultUserAccount.id = UserAccount.nextID();
    const currUserAccounts = getDefaultData().userAccounts;
    const updatedUserAccounts = [ defaultUserAccount, ...currUserAccounts ];

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["userAccounts"], updatedUserAccounts)
    .submit();
    
    return <UsersPage data={ data } />;
}